<template>
  <section class="members">
    <ul v-if="members && members.length" class="member-list">
      <li v-for="email of members" :key="email" class="member-list-item">
        {{ email }}

        <yn-button
          v-if="members.length > 1 || role === 'annotator'"
          variant="text"
          title="Remove this member"
          @click.prevent.stop="remove(email)"
          >&times;</yn-button
        >
      </li>
    </ul>
    <yn-add-member :id="id" :role="role" :collection="members" />
  </section>
</template>

<script>
import { mapState } from 'vuex';

import AddMember from './AddMember';
import Button from '@/components/common/Button';

export default {
  components: {
    'yn-add-member': AddMember,
    'yn-button': Button
  },
  props: {
    id: {
      type: String,
      required: true
    },
    role: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      members: []
    };
  },
  computed: {
    ...mapState({
      item: s => s.topics.item,
      annotators: s => s.topics.item.annotators,
      administrators: s => s.topics.item.administrators
    })
  },

  watch: {
    item: {
      handler() {
        if (this.role === 'administrator') {
          this.members = this.item.administrators;
        } else {
          this.members = this.item.annotators;
        }
      },
      deep: true,
      immediate: true
    }
  },
  methods: {
    async remove(email) {
      const lock = this.$lock();
      try {
        await this.$store.dispatch(
          this.role === 'administrator' ? 'topics/removeAdministrator' : 'topics/removeAnnotator',
          {
            id: this.id,
            email
          }
        );

        this.$toast.success({
          title: 'Update completed',
          message: `Member '${email}' was removed from this topic.`
        });
      } catch (e) {
        this.$toast.error({
          title: 'Update failed',
          message: `Please, try again later or contact our development team.`
        });
      } finally {
        lock.release();
      }
    }
  }
};
</script>

<style scoped lang="scss">
.members {
  .add-member-form {
    display: grid;
    grid-template-columns: 1fr max-content;
    grid-gap: 2rem;
    align-items: center;
  }
  .member-list {
    margin-bottom: 2rem;
  }
}
</style>
